import React, {useEffect, useState} from 'react';
import {Alert, Card, Container} from 'react-bootstrap';
import Button from "react-bootstrap/Button";
import {
    getAttachedFiles,
    setDocumentSent,

} from "../services/PandaDocService";
import Col from 'react-bootstrap/Col'
import {getLeadAPI} from "../services/Leadservice";
import {useAuth} from "../contexts/AuthContext";
import {ConfirmAttachmentModal} from './ConfirmAttachmentModal'
import {API_KEY, dealstages, formatText} from "./CONSTANTS";
import LoadingLoginScreen from "./LoadingLoginScreen";
import {AcceptAndSendQuoteModal} from "./AcceptAndSendQuoteModal";
import {GuideText} from "./GuideText";

export default function Quote({match}) {

    const {currentUser} = useAuth();
    const [lead, setLead] = useState({});
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [errorText, setErrorText] = useState("");
    const [pandadocdetails, setpandadocdetails] = React.useState({});
    const [showIframe, setShowIframe] = useState(false);
    const [sessionID, setSessionID] = useState("");


    const fetchAttachments = React.useCallback(async () => {


        try {
            let leadData = await getLeadAPI(match.params.id)
            setLead(leadData)


            let myHeaders = new Headers();
            myHeaders.append("Authorization", API_KEY);

            let requestOptions = {
                method: 'GET',
                headers: myHeaders,
                redirect: 'follow'
            };

            await fetch(`https://api.pandadoc.com/public/v1/documents/${leadData.pandadocID}/attachments/`, requestOptions)
                .then(response => response.json())
                .then(async result => {
                    setpandadocdetails(result[0])

                })
                .catch(error => console.log('error', error));
        } catch
            (e) {
            console.error(e);
        }
    }, []);

    useEffect(() => {
        setLoading(true)


        fetchAttachments();
        setLoading(false)


    }, [match.params.id])


    const handleSendDocument = async () => {
        setLoading(true);


        await setDocumentSent(lead.pandadocID, lead.email, lead.firstname).then(() => {
            setError(true);
            setErrorText(`Skickat till ${lead.email}`);
        }).then(async () => {

            await window.location.reload();
        })

        setLoading(false);
    }

    /*

    const handleGetSessionID = async () => {

        await getPandaDocSessionID(match.params.id, lead.pandadocID, lead.email)

        setSessionID(lead.sessionID)

        setError(true);
        setErrorText("Sessionsid hämtat")

        setLoading(false)
    }

    const handleCheckDocumentStatus = async () => {


        if (lead.pandadocID === undefined) {
            setError(true)
            setErrorText("Du behöver färdigställa en offert innan du förhandsvisar offerten")
            return false;
        } else {
            try {
                setShowStatus(!showStatus)
                await checkDocumentStatus(match.params.id, lead.pandadocID)
            } catch (e) {

            }
        }
    }


    const handleDownloadFile = async () => {
        try {
            await downloadFileFromPandadocAPI(lead.pandadocID)
        } catch (e) {
            setError(true)
            setErrorText("Fel uppstod vid nedladdning av fil")
        }
    }
     */


    return (
        <>

            {loading ? <LoadingLoginScreen/> :
                <Container fluid={"sm"} style={{padding: 10}}>
                    <Container style={{padding: 10}}>
                        {error || loading ? (
                                <React.Fragment fluid={"sm"}>


                                    {/*
                                <Alert variant={"warning"}>{declareGuideText(lead.dealstage)}</Alert>
                            */}
                                </React.Fragment>
                            ) :
                            <React.Fragment>

                                {/*

                                <Alert variant={"success"}>{declareGuideText(lead.dealstage)}</Alert>
*/}

                            </React.Fragment>

                        }
                        <Card className={"card-header"}>

                            <Alert variant={"success"}>Offert
                                till {lead.firstname + " " + lead.lastname}, Email: {lead.email} </Alert>

                            {lead.pandadocID === "" ? null :
                                <Alert variant={"success"}>
                                    Offertnummer {lead.pandadocID}
                                </Alert>}
                        </Card>
                    </Container>
                    {lead.dealstage === dealstages.OFFERTGODKAND || dealstages.OFFERTSEDD || dealstages.OFFERTNEKAD ? null :
                        <GuideText dealstage={lead.dealstage} email={lead.email}/>}

                    <Container style={{padding: 10}}>
                        <Col>
                            <React.Fragment>


                                <hr/>
                                <Card>
                                    <Card.Header>
                                        Status:
                                    </Card.Header>
                                    <Card.Body>
                                        Offertstatus:
                                        <b>
                                            {formatText(lead.status)}
                                        </b>
                                        <hr/>
                                        {pandadocdetails ? <React.Fragment>
                                            Bifogade filer: {pandadocdetails.name}</React.Fragment> : <React.Fragment>
                                            Inga filer bifogade ännu.
                                        </React.Fragment>}

                                    </Card.Body>
                                    {lead.pandadocdocname}
                                </Card>
                                {lead.dealstage === "appointmentscheduled" ?
                                    <Card>
                                        <Card.Header>Bifoga fil efter att offerten är skapad</Card.Header>
                                    </Card>
                                    : undefined


                                }

                            </React.Fragment>


                            {showIframe && sessionID ? (
                                <div>
                                    <iframe src={`https://app.pandadoc.com/s/${sessionID}`}
                                            width="900" height="600"/>
                                </div>
                            ) : undefined}


                            {lead.pandadocID === "" ?
                                <Container fluid>

                                    <AcceptAndSendQuoteModal
                                        customer={lead.email}
                                        service={lead.service}
                                        currentUser={currentUser}
                                        amount={lead.value}
                                        lead={lead}
                                        file={lead.pdfFileName}
                                        docid={match.params.id}
                                    />

                                </Container> : null
                            }
                            <Col>

                                {lead.dealstage === dealstages.INKOMMENLEAD || lead.dealstage === dealstages.OFFERTSKICKAD
                                || lead.dealstage === dealstages.OFFERTGODKAND
                                    ? null :
                                    <React.Fragment>
                                        <ConfirmAttachmentModal pandadocID={lead.pandadocID}
                                                                fsdocid={match.params.id}


                                        />
                                    </React.Fragment>

                                }

                                {lead.status === "document.draft" && lead.pdfFileName !== "" ?


                                    <Button style={{margin: 20}} variant={"primary"}
                                            onClick={() => handleSendDocument()}

                                    >
                                        Skicka offert till {lead.email}
                                    </Button>

                                    : null}</Col>

                        </Col>

                    </Container>
                </Container>
            }
        </>


    )
}
